import ReactDOM from 'react-dom/client';

import { Suspense } from 'react';
import { AppRouter } from './routers/app.router';
import { Loading } from './components/Loading';

import './plugins';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
    <Suspense fallback={<Loading />}>
        <AppRouter />
    </Suspense>,
);
